export default "__VITE_ASSET__D1a9trQW__"